<script>
import { BFormValidFeedback } from "bootstrap-vue";

export default {
  extends: BFormValidFeedback
};
</script>